export type FAQ = { question: string; answer: string };

export const overallFAQs: FAQ[] = [
  {
    question: 'What is Equipool?',
    answer:
      'Equipool is a platform that connects investors with borrowers seeking fair, fast, and transparent financing backed by real assets. Borrowers get access to flexible capital, while investors earn strong, secured returns on tangible collateral.',
  },
  {
    question: 'How does Equipool work?',
    answer:
      'Equipool matches borrowers and investors based on the requested amount, asset type, risk profile, and preferred terms. Once a match is made, the agreement is finalized through a secure process and the file is transferred to a third-party escrow company for processing. After escrow is completed, the title company disburses the funds and the file is assigned to a servicing company that manages the loan for its entire duration.',
  },
  {
    question: 'Is Equipool a bank?',
    answer: 'No. Equipool is a tech company that connects borrowers and investors using this platform.',
  },
  {
    question: 'Is Equipool safe to use?',
    answer:
      'Yes. The platform uses bank-level encryption, secure identity verification, and strict compliance protocols to protect all users. Equipool also does not sell, share, or monetize user data in any way.',
  },
];

export const borrowerFAQs: FAQ[] = [
  {
    question: 'What types of loans can I get through Equipool?',
    answer: 'Loans secured by real estate assets.',
  },
  {
    question: 'How fast can I receive funding?',
    answer:
      'The funding process involves two stages. After a pool is created, response times vary because investors independently choose which pools to engage with. Once an investor accepts or submits a counteroffer, the borrower has 72 hours to accept or respond. If no offer or acceptance is received within 21 days, the borrower may return to their original request and adjust the terms.',
  },
  {
    question: 'What are the borrower requirements?',
    answer:
      'Requirements vary by loan type, but generally include verifiable asset ownership, valuation of collateral, and valid identification and business documentation (if applicable).',
  },
  {
    question: 'How are loan terms determined?',
    answer:
      'Borrowers set their own proposed terms, which are subject to investor acceptance or counteroffer. Terms typically consider collateral value, loan amount, borrower risk profile, preferred interest rate, and preferred loan term.',
  },
  {
    question: 'Do you check my credit?',
    answer:
      'Credit checks may be performed depending on loan type, but collateral-backed requests often rely more heavily on asset value than credit scores.',
  },
  {
    question: "What happens if I'm late on a payment?",
    answer:
      'Late payments incur standard fees outlined in your loan agreement. If the loan remains unpaid, the collateral may be used to recover the outstanding amount.',
  },
];

export const investorFAQs: FAQ[] = [
  {
    question: 'How can I invest through Equipool?',
    answer:
      'Investors begin by registering on the platform using their provided qualification code. Once registration and verification are complete, investors gain access to a list of active pool requests. From there, they can review opportunities based on loan type, risk level, and asset class. Investors may accept proposed terms or submit a counteroffer.',
  },
  {
    question: 'How can I get my qualification code?',
    answer: 'To obtain your qualification code, please contact one of our authorized agents in your area.',
  },
  {
    question: 'How is my investment protected?',
    answer:
      'All loans are backed by real, tangible assets. The documentation and closing process are handled by a licensed escrow company and insured through a title company.',
  },
];
